import { Leaf, BookOpen, Sparkles } from "lucide-react";

export const SECTORS = {
  wellness: {
    key: "wellness",
    name: "Business Wellness",
    short: "Wellness",
    icon: Leaf,
    hex: "#10B981",
    soft: "rgba(16,185,129,0.12)",
    border: "rgba(16,185,129,0.35)",
    grad: "from-emerald-500 to-teal-600",
    text: "text-emerald-400",
  },
  book: {
    key: "book",
    name: "Progetto Libro",
    short: "Libro",
    icon: BookOpen,
    hex: "#3B82F6",
    soft: "rgba(59,130,246,0.12)",
    border: "rgba(59,130,246,0.35)",
    grad: "from-blue-500 to-indigo-600",
    text: "text-blue-400",
  },
  ai: {
    key: "ai",
    name: "AI allo Specchio",
    short: "AI allo Specchio",
    icon: Sparkles,
    hex: "#8B5CF6",
    soft: "rgba(139,92,246,0.12)",
    border: "rgba(139,92,246,0.35)",
    grad: "from-violet-500 to-fuchsia-600",
    text: "text-violet-400",
  },
};

export const SECTOR_KEYS = ["wellness", "book", "ai"];

export const CONTENT_TYPES = ["post", "reel", "video", "tutorial", "storia"];
export const CONTENT_STATUS = ["idea", "bozza", "programmato", "pubblicato"];

export function SectorChip({ sector, className = "" }) {
  const s = SECTORS[sector];
  if (!s) return null;
  const Icon = s.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${className}`}
      style={{ background: s.soft, color: s.hex, border: `1px solid ${s.border}` }}
      data-testid={`sector-chip-${sector}`}
    >
      <Icon className="h-3.5 w-3.5" /> {s.short}
    </span>
  );
}
